export default "__VITE_ASSET__288a2dde__"